// H5登录资源
import type { RouteConfig } from 'vue-router';
import { RouterH5Enum } from '../router-names';

export default (): RouteConfig[] => ([
  {
    path: RouterH5Enum.loginCaptcha,
    name: RouterH5Enum.loginCaptcha,
    component: () => import(
      /* webpackChunkName: "login" */ '@/viewsH5/login/login-captcha'
    ),
    meta: {
      pageId: '臻有钱_登录页_图形验证码',
      title: '输入验证码',
      needLogin: false,
    },
    props: (route) => ({
      backUrl: String(route.query.backUrl || ''),
    }),
  },
  {
    path: RouterH5Enum.loginSms,
    name: RouterH5Enum.loginSms,
    component: () => import(
      /* webpackChunkName: "login" */ '@/viewsH5/login/login-sms-code'
    ),
    meta: {
      pageId: '臻有钱_登录页_短信验证码',
      title: '输入短信验证码',
      needLogin: false,
    },
    props: (route) => ({
      /** 回跳 */
      backUrl: String(route.query.backUrl || ''),
    }),
  },
  {
    path: RouterH5Enum.redirectApp,
    name: 'h5RedirectApp',
    component: () => import(/* webpackChunkName: "login" */ '@/viewsH5/redirect-app'),
    meta: {
      pageId: '臻有钱_下载app',
      title: '下载app',
    },
  },
  {
    path: RouterH5Enum.redirectAppForDeposit,
    name: 'h5RedirectAppForDeposit',
    component: () => import(/* webpackChunkName: "login" */ '@/viewsH5/redirect-app'),
    meta: {
      pageId: '臻有钱_下载app',
      title: '下载app',
      message: '购买存款产品需先开通该银行电子账户\n下载哈啰出行APP立即开通',
    },
  },
]);
